<template>
    <div id="contendor-principal-menus" class="container-fluid">
        <div id="encabezados">
            <h1>ADMINISTRACIÓN DE MENÚS</h1>
            <h4>Agrega, modifica o da de baja los menús de la página web</h4>
        </div>
        <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <transition name="fade">
            <div class="seccion-filtrosDeBusqueda mt-4" v-show="!ocultarFiltros">
                <div class="titulo-contendor">
                    <div class="form-inline justify-content-between">
                        <h4>Filtros de búsqueda</h4>
                        <!-- <button v-if="submenus.actualizacionDeFiltros.actualizar" @click="submenus.actualizacionDeFiltros.actualizar = false, submenus.actualizacionDeFiltros.contRender += 1" type="button" class="btn btn-sm btn-light"><i class="fas fa-sync-alt"></i></button> -->
                    </div>
                </div>
                <CFiltrosDeBusquedaMenus
                    :ID_COMPONENTE="C_FILTROS_BUSQUEDA_ID"
                    class="contenedor-gris"
                    v-on:RealizarBusquedaDeMenus="evtBusquedaMenus"></CFiltrosDeBusquedaMenus>
            </div>
        </transition>
        <!-- FIN SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <div :class="[(ocultarFiltros) ? 'd-flex justify-content-center align-items-center seccion-filtrosDeBusqueda' : 'd-flex justify-content-center align-items-center mt-4']">
            <hr style="flex: 1; border: none; height: 3px; background: white; margin-right: 2em;">
                <button  type="button" class="btn btn btn-light" @click="ocultarFiltros = !ocultarFiltros">
                    <i :class="[(ocultarFiltros) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (ocultarFiltros) ? 'Mostrar' : 'Ocultar'}} filtros
                </button>
            <hr style="flex: 1; border: none; height: 3px; background: white;  margin-left: 2em;">
        </div>
        <!-- SECCION CRUD PARA MENUS -->
        <div id="seccion-crud" class="mt-4">
            <div class="titulo-tabla">
                <div class="row">
                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2 pt-1"><h4>Administración de menús</h4></div>
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1 d-flex justify-content-end">
                        <div class="d-flex">
                            <button v-if="menus.memoria.length > 0 && permiteMoodificarOrden" @click="evtMostrarModalOrdenamiento" type="button" class="mr-2 btn btn-light"><i class="fas fa-sort-numeric-up"></i></button>
                            <button type="button" @click="evtMostrarFormulario(false)" class="btn btn btn-light mr-4"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="tabla-menus-SICPO-VADM" class="contenedor-gris table-responsive">
                <div v-if="menus.seleccionados.length > 1" id="accion-estatus-menus" class="form-inline justify-content-end">
                    <h6 @click="evtMostrarModalCambioEstatus" class="mr-3"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar estatus</h6>
                </div>
                <table
                    class="table table-striped table-light table-hover"
                    id="tabla-menus"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"
                    data-maintain-selected="true"  
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-search="true">
                    <thead class="thead-dark">
                        <tr>
                            <th data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="MenuId" data-sortable="true">
                                Folio
                            </th>
                            <th data-halign="center" data-width="20" data-align="center" data-field="PaginaDeInicio.Titulo" data-sortable="true">
                                Página donde se muestra
                            </th>
                            <th data-halign="center" data-width="15" data-align="center" data-field="TipoPosicion.Nombre" data-sortable="true">
                                Se muestra en posición
                            </th>
                            <th data-halign="center" data-width="20" data-align="center" data-field="Titulo" data-sortable="true">
                                Título
                            </th>
                            <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="EstaActivo.html" data-halign="center" data-align="center">
                                Activo
                            </th>
                            <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <!-- FIN SECCION CRUD PARA MENUS -->
        <!-- MODAL PARA CAMBIO DE ESTATUS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-estatus-VAM">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <div class="form-inline justify-content-center mb-3">
                                <i v-if="menus.activarVariosMenus" class="fas fa-eye icono-activacion-menus"></i>
                                <i v-if="!menus.activarVariosMenus" class="fas fa-eye-slash icono-activacion-menus"></i>
                            </div>
                            <div class="form-inline justify-content-center text-center mb-2">
                                <h4 v-if="!menus.activarVariosMenus">El menú se dejara de mostrar en la pagina web</h4>
                                <h4 v-if="menus.activarVariosMenus">El menú se mostrara en la pagina web</h4>
                            </div>
                            <div class="form-inline justify-content-center"> 
                                <h6 class="pr-2">Estatus activo:</h6>
                                <label class="switch">
                                    <input id="switch-cambio-estatus-modal-VAM" type="checkbox" @change="evtSwitchActivacionVariosSubmenus">
                                    <div class="slider"></div>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1 acciones-activacion-menus"><button type="button" class="btn btn-block btn-primary" @click="evtCerrarModalActivacion"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                            <div class="col-6 pr-1 pl-1 acciones-activacion-menus"><button type="button" class="btn btn-block btn-primary" @click="evtCambiarEstatusMenus"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- FIN MODAL PARA CAMBIO DE ESTATUS -->
        <!-- MODAL PARA FORMULARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-formulario-menus">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ formulario.tituloFormulario }}</h5>
                        <button  id="btn-cerrar-modal-formulario-menus" class="close" @click="evtCerrarFormulario" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div v-if="formulario.mostrarErrores && !this.formularioEsValido()" class="form-group">
                            <div id="contenedor-error-formulario">
                                <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                <span style="text-align: justify; display:block;">{{ formulario.mensajeError }}</span>
                            </div>
                        </div>
                        <div class="form-group d-flex align-items-center justify-content-between">
                            <i>Los campos con (*) son obligatorios.</i>
                            <button v-if="!formulario.esEdicion" type="button" @click="evtIniciarProcesoAltaMenu" class="btn btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            <button v-if="formulario.esEdicion" type="button" @click="evtIniciarProcesoModificacionDeMenu" class="btn btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                        <div class="form-group contenedor-color-negro container-fluid">
                            <!-- PAGINA DONDE SE MUESTRA SUBMENU -->
                            <div class="form-group deshabilitarSeccionCatalogos">
                                <h6>Página donde se muestra menú (*)&nbsp;
                                        <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.catalogoPaginasDeInicio.valorDefinido)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.catalogoPaginasDeInicio.valorDefinido)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C001PaginaInicio  
                                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                                    v-on:valorParaElPadre="evtCambioPaginaInicio" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="formulario.catalogoPaginasDeInicio.ID" 
                                    :parametros="formulario.catalogoPaginasDeInicio.parametros" 
                                    :valorDefinido="formulario.catalogoPaginasDeInicio.valorDefinido" 
                                    :key="formulario.catalogoPaginasDeInicio.KEY + formulario.catalogoPaginasDeInicio.contRender"></C001PaginaInicio>
                            </div>
                            <!-- POSICION DONDE SE MUESTRA SUBMENU -->
                            <div class="form-group">
                                <h6>Posición donde se muestra menú (*)&nbsp;
                                        <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.catalogoTiposPosiciones.valorDefinido)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.catalogoTiposPosiciones.valorDefinido)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C005TiposPosicion  
                                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                                    v-on:valorParaElPadre="evtCambioPosicion" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="formulario.catalogoTiposPosiciones.ID" 
                                    :parametros="formulario.catalogoTiposPosiciones.parametros" 
                                    :valorDefinido="formulario.catalogoTiposPosiciones.valorDefinido" 
                                    :key="formulario.catalogoTiposPosiciones.KEY + formulario.catalogoTiposPosiciones.contRender"></C005TiposPosicion>
                            </div>
                            <!-- TITULO DE MENU -->
                            <div class="form-group">
                                <h6>Titulo del menú (*)&nbsp;
                                    <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.titulo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.titulo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formulario.titulo" type="text" id="titulo_menu1" class="form-control" placeholder="Ingrese el titulo del menú" />
                            </div>
                            <!-- CARACTERISTICAS DE MENU -->
                            <hr v-if="formulario.iconos.lista.length > 0 && this.mostrarCaracteristicasExtra" style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <div class="row" v-if="this.mostrarCaracteristicasExtra">
                                <!-- ES MENU ESPECIAL -->
                                <div class="form-inline col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                                   <h6 class="mr-2">Es menú especial</h6>
                                   <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.esMenuEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esMenuEspecial = true, formulario.esDescarga = true">
                                            <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>SI
                                        </label>
                                        <label :class="[!formulario.esMenuEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esMenuEspecial = false, formulario.esDescarga = false">
                                            <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >NO
                                        </label>
                                    </div>
                                </div>
                                <!-- MENU PARPADEA -->
                                <div class="form-inline col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                                   <h6 class="mr-2">El menú parpadea</h6>
                                   <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.elMenuParpadea ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.elMenuParpadea = true">
                                            <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>SI
                                        </label>
                                        <label :class="[!formulario.elMenuParpadea ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.elMenuParpadea = false">
                                            <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >NO
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <!-- SWITCH ES DESCARGA -->
                            <!-- <div v-if="formulario.esMenuEspecial || formulario.catalogoTiposPosiciones.valorDefinido == formulario.catalogoTiposPosiciones.POSICION_IZQUIERDA" class="mt-0">
                                <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                    <label :class="[formulario.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDescarga = true">
                                        <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>MENU ES DESCARGA
                                    </label>
                                    <label :class="[!formulario.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDescarga = false">
                                        <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >MENU ES RUTA DE ACCESO
                                    </label>
                                </div>
                            </div> -->
                            <!-- SI ES DESCARGA MUESTRA SUBIDOR -->
                            <div class="form-inline" v-if="(this.campoRequeridoEsValido(menus.seleccionadoEdicion) && menus.seleccionadoEdicion.EsDescarga) && 
                                                            formulario.esEdicion && !formulario.archivo.esConSubidor && formulario.esDescarga">
                                <i class="pr-2">Archivo de acceso actual: {{ this.obtenerNombreDelArchivo(menus.seleccionadoEdicion.RutaParaAccesar) }}</i>
                                <button type="button" class="btn btn-sm btn-success" @click="evtDescargarArchivo(menus.seleccionadoEdicion.RutaParaAccesar)"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                            </div>
                            <!-- SUBIDOR DE ARCHIVOS -->
                            <div class="form-group" v-show="formulario.esDescarga">
                                <h6>Seleccione el archivo de descarga (*)&nbsp;
                                    <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.archivo.objeto)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.archivo.objeto)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input type="file" id="archivo_menu" class="form-control" v-on:change="evtSubidorDeArchivo($event)" :accept="formulario.archivo.EXTENSIONES" />
                            </div>
                            <!-- RUTA DE ACCESO -->
                            <div class="form-group" v-show="!formulario.esDescarga">
                                <!-- <h6>Url de acceso (*)&nbsp;
                                    <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.url)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.url)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6> -->
                                <h6>Url de acceso</h6>
                                <input v-model="formulario.url" type="text" id="ruta_acceso" class="form-control" placeholder="Ingrese la url de acceso del menú" />
                            </div>
                            <!-- ICONOS DE MENUS -->
                            <hr v-if="this.mostrarIconos" style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <div class="form-group" v-if="this.mostrarIconos">
                                <h6>Selecciona el icono del menú (*)&nbsp;
                                    <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.iconos.seleccionado)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.iconos.seleccionado)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <CListaDeImagenes  
                                    :idDivPadre="formulario.iconos.ID"
                                    :esParaIconos="true"
                                    :estilosExtraDiv="'display: inline-block; border-radius:8px; overflow-y: auto; background-color:#212529; max-height: 212px;'" 
                                    :estilosExtraUl="'margin-left: 3.5em; margin-bottom: 1em;  padding-top: 1em;'" 
                                    v-on:cargarImagenes="recargarIconos" 
                                    v-on:valorParaElPadre="evtSeleccionDeIcono" 
                                    :idListaDeImagenes="formulario.iconos.ID + '-LI-VADM'" 
                                    :listaDeImagenes="formulario.iconos.lista"
                                    :ref="formulario.iconos.REF"
                                    :key="formulario.iconos.KEY + formulario.iconos.contRender"></CListaDeImagenes>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL PARA ORDENAMIENTO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-ordenamiento-menusPW">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordenamiento de menús</h5>
                        <button  id="btn-cerrar-modal-ordenamiento-menusPW" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div v-if="ordenamiento.listaOrdenamiento.length > 0">
                            <div id="informacion-ordnamiento" class="form-inline">
                                <i class="fas fa-info-circle"></i>&nbsp;
                                <i>Selecciona y desplaza los menús para cambiar el orden.</i>
                            </div>
                            <div id="lista-ordenamiento-menus" class="mt-2">
                                <ClistaOrdenable
                                    :elementos="ordenamiento.listaOrdenamiento"
                                    :referenciasElemento="ordenamiento.REFERENCIAS"
                                    :informacionAmostrar="ordenamiento.CAMPOS"
                                    v-on:ModificacionEnListaDeElementos="evtOrdenDeMenusSeModifico"></ClistaOrdenable>
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                                <button type="button" class="btn btn-sm btn-light mr-2" @click="evtIniciarCambioOrdenMenus(ordenamiento.TIPO.ALFABETICO)"><i class="fas fa-sort-alpha-down"></i>&nbsp;Ordenar alfabéticamente</button>
                                <button type="button" @click="evtIniciarCambioOrdenMenus(ordenamiento.TIPO.DESPLAZAMIENTO)" class="btn btn-sm btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalInformativo.titulo }}</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>{{ modalInformativo.mensaje }}</h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import catalogos from '@/../static/js/catalogos'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import CFiltrosDeBusquedaMenus from '@/components/SICPO/PaginaWeb/Menus/CFiltrosDeBusquedaMenus.vue';
import ClistaOrdenable from '@/components/SICPO/Comun/ClistaOrdenable.vue'

export default {
    components: {
        C005TiposPosicion: catalogos.SICPO.C005TiposPosicion,
        C001PaginaInicio: catalogos.SICPO.C001PaginaInicio,
        CFiltrosDeBusquedaMenus,
        CListaDeImagenes,
        ClistaOrdenable
    },
    data() {
        return {
            enumeraciones,
            C_FILTROS_BUSQUEDA_ID: 'FB_AdmistracionMenusPW',
            ocultarFiltros: false,
            modalInformativo: {
                titulo: 'Mensaje del sistema',
                mensaje: '',
                funcionConfirmar: () => {},
                funcionCancelar: () => {}
            },
            menus: {
                filtrosDeBusqueda: null,
                BD: [],
                memoria: [],
                seleccionado: null,
                seleccionados: [],
                activarVariosMenus: false,
                seleccionadoEdicion: null
            },
            ordenamiento: {
                listaOrdenamiento: [],
                listaNuevoOrden: [],
                REFERENCIAS: { folio: 'MenuId', orden: 'OrdenDelMenu',fechaPublicacion: 'fp', descripcion: 'Titulo' },
                CAMPOS: { folio: true, fechaPublicacion: false, descripcion: true },
                TIPO: { DESPLAZAMIENTO: 1, ALFABETICO: 2 }
            },
            formulario: {
                tituloFormulario: 'Alta de menú',
                mostrarErrores: false,
                mensajeError: null,
                esEdicion: false,
                catalogoPaginasDeInicio: {
                    ID: 'CPaginaInicioVAM',
                    REF: 'REFPaginaInicioVAM',
                    parametros: { PaginaDeInicioId: null, TipoPaginaId: 1, PaginaWebId: null, PaginaMicrositioId: null, MenuId: null, ConInactivas: false, ConMenus: false, ConPaginasWeb: false, ConPaginasMicrositios: false },
                    valorDefinido: 1,
                    paginaSeleccionada: null,
                    KEY: 'KPaginaInicioVAM',
                    contRender: 0
                },
                catalogoTiposPosiciones: {
                    ID: 'CTiposDePosicionVAM',
                    REF: 'REFTiposDePosicionVAM',
                    POSICIONES: {
                        SUPERIOR: { llave: 1 },
                        IZQUIERDA: { llave: 3 },
                        DERECHO: { llave: 4}
                    },
                    parametros: { TipoPosicionId: null, MenuId: null, ConInactivos: false, ConMenus: false },
                    valorDefinido: -1,
                    posicionSelccionada: null,
                    KEY: 'KTiposDePosicionVAM',
                    contRender: 0
                },
                esDescarga: false,
                archivo: {
                    EXTENSIONES: '.PDF,XLSX',
                    esConSubidor: false,
                    objeto: null,
                    IDENTIFICADOR: 'ARCHIVO-MENU'
                },
                url: null,
                titulo: null,
                iconos: {
                    ID: 'ID-ListaDeIconos-VADM',
                    REF: 'REF-ListaDeIconos-VADM',
                    seleccionado: null,
                    lista: [],
                    KEY: 'KEY-ListaDeIconos-VADM',
                    contRender: 0,
                    requerido: false
                },
                esMenuEspecial: false,
                elMenuParpadea: false
            }
        }
    },
    methods: {
        evtIniciarCambioOrdenMenus: async function(tipoDeOrdenamiento) {
            const { TIPO } = this.ordenamiento;
            switch(tipoDeOrdenamiento) {
                case TIPO.DESPLAZAMIENTO:
                    const MENUS_NUEVO_ORDEN = await Promise.resolve(this.actualizarOrdenEnListaDeMenus());
                    if(MENUS_NUEVO_ORDEN.length > 0) {
                         const PETICION = { Menus: MENUS_NUEVO_ORDEN, esPrueba: false };
                         $("#modal-ordenamiento-menusPW").modal('hide');
                         await Promise.resolve(this.modificarOrdenamientoMenusBD(PETICION, tipoDeOrdenamiento));
                    }
                    break;
                case TIPO.ALFABETICO:
                        let peticion = {};
                        peticion.Menus = this.menus.BD.filter(mbd => mbd.Activo).map(m => {
                            let menuObj = { 
                                MenuId: m.MenuId, 
                                EsDescarga: false,
                                Activo: false,
                                EsMenuEspecial: false,
                                ElMenuParpadea: false
                            };
                            return menuObj;
                        });
                        peticion.esPrueba = false;
                        $("#modal-ordenamiento-menusPW").modal('hide');
                        await Promise.resolve(this.modificarOrdenamientoMenusBD(peticion, tipoDeOrdenamiento));
                    break;
                default:
                    break;
            }
        },
        modificarOrdenamientoMenusBD: async function(peticionAPI, TIPO_ORDENAMIENTO) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = (TIPO_ORDENAMIENTO == this.ordenamiento.TIPO.DESPLAZAMIENTO)
                    ? api.SICPO.sistema.paginaweb.administracionDeMenus.ModificarOrdenamientoDeMenusPW
                    : api.SICPO.sistema.paginaweb.administracionDeMenus.OrdenarAlfabeticamenteMenusPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_MODIFICAR_MENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_MODIFICAR_MENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-ordenamiento-menusPW").modal('show');
                } 
                else {
                    const ES_PARA_ACTUALIZAR = true;
                    await Promise.resolve(this.obtenerMenusBD(ES_PARA_ACTUALIZAR, Satisfactorio));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        actualizarOrdenEnListaDeMenus: async function() {
            let listaOrdenada = [];
            if(this.campoRequeridoEsValido(this.ordenamiento.listaNuevoOrden) && this.ordenamiento.listaNuevoOrden.length > 0) {
                let orden = 1;
                listaOrdenada = this.ordenamiento.listaNuevoOrden.map(m => {
                    let menuObj = { 
                        MenuId: m.MenuId, 
                        EsDescarga: false,
                        Activo: false,
                        OrdenDelMenu: orden,
                        EsMenuEspecial: false,
                        ElMenuParpadea: false
                    };
                    orden ++;
                    return menuObj;
                });
            }
            return listaOrdenada;
        },
        evtMostrarModalOrdenamiento: function() {
            $("#modal-ordenamiento-menusPW").modal('show');
        },
        evtOrdenDeMenusSeModifico: function(editado, listaDeMenus) {
            this.ordenamiento.listaNuevoOrden = listaDeMenus;
            console.log('listaDemenus::nuevoOrden::',this.ordenamiento.listaNuevoOrden);
        },
        cargarDatosDeMenuEnFormulario: async function() {
            let { MenuId, RutaParaAccesar, Titulo, EsDescarga, EsMenuEspecial, ElMenuParpadea, TipoIcono, PaginaDeInicio, TipoPosicion } = this.menus.seleccionadoEdicion;
            this.formulario.tituloFormulario = `Edicion de menu #Folio[ ${MenuId} ]`;
            // se llena catalogo de posicion
            this.formulario.catalogoTiposPosiciones.valorDefinido = TipoPosicion.TipoPosicionId;
            this.formulario.catalogoTiposPosiciones.contRender ++;
            this.formulario.titulo = Titulo;
            this.formulario.esDescarga = EsDescarga;
            this.formulario.esMenuEspecial = EsMenuEspecial;
            this.formulario.elMenuParpadea = ElMenuParpadea;
            this.formulario.url = (!EsDescarga) ? RutaParaAccesar : null;
            this.cargarIconoDeMenu(TipoIcono);
        },
        cargarIconoDeMenu: async function(icono) { 
            if(this.campoRequeridoEsValido(icono)) {
                this.formulario.iconos.seleccionado = this.formulario.iconos.lista.find(i => i.llave == icono.TipoIconoId);
                this.$nextTick(async () => {
                    $("#" + icono.TipoIconoId).trigger("click");
                    // cuando actualiza estos valores, la tabla se actualiza y pierde los valores de los switch
                    await Promise.resolve(this.persistirSwitchMenusActivos());
                });
            }
        },
        evtIniciarProcesoModificacionDeMenu: async function() {
            const FORMULARIO_ES_VALIDO = this.formularioEsValido();
            if(FORMULARIO_ES_VALIDO) {
                this.formulario.mostrarErrores = false;
                const PETICION_GUARDAR_MENU = await Promise.resolve(this.crearPeticionGuardarMenu());
                // SOLO PARA DESARROLLO DESPUES COMENTAR
                for (var pair of PETICION_GUARDAR_MENU.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                //
                const ES_NUEVO_MENU = false;
                $("#modal-formulario-menus").modal('hide');
                await Promise.resolve(this.guardarNuevoMenuBD(PETICION_GUARDAR_MENU, ES_NUEVO_MENU));
            }
        },
        crearPeticionGuardarMenu: async function() {
            const { catalogoPaginasDeInicio, catalogoTiposPosiciones, titulo, esDescarga, archivo, url, esMenuEspecial, elMenuParpadea, iconos } = this.formulario;
            const { POSICIONES } = this.formulario.catalogoTiposPosiciones;
            let peticion = new FormData();
            let menuObj = this.menus.seleccionadoEdicion;
            const ACTUALIZAR_ORDEN_MENU = this.actualizarOrdenDeMenu(catalogoTiposPosiciones.valorDefinido);
            menuObj.RutaParaAccesar = (esDescarga) ? (archivo.esConSubidor) ? archivo.IDENTIFICADOR : menuObj.RutaParaAccesar : url;
            menuObj.Titulo = titulo;
            menuObj.EsDescarga = esDescarga; // representa el valor de esDescarga y menuEspecial
            menuObj.EsMenuEspecial = esMenuEspecial;
            menuObj.ElMenuParpadea = elMenuParpadea;
            menuObj.TipoIcono = null;
            if(this.campoRequeridoEsValido(iconos.seleccionado) && this.mostrarIconos) {
                let iconoObj = { TipoIconoId: iconos.seleccionado.llave, Icono: null, UsablePorUsuario: false, Activo : false } // solo requerido el atributo TipoIconoId
                menuObj.TipoIcono = iconoObj;
            } 
            menuObj.PaginaDeInicio = { PaginaDeInicioId: catalogoPaginasDeInicio.valorDefinido, Activo: true };
            menuObj.TipoPosicion = { TipoPosicionId: catalogoTiposPosiciones.valorDefinido, Activo: true };
            if(esMenuEspecial && esDescarga && archivo.esConSubidor)
                peticion.append(archivo.IDENTIFICADOR, archivo.objeto);
            peticion.append('ReferenciaArchivo', archivo.IDENTIFICADOR);
            peticion.append('Menu', JSON.stringify(menuObj));
            peticion.append('EsPrueba', false);
            peticion.append('ActualizarOrdenDeMenu', ACTUALIZAR_ORDEN_MENU);
            return peticion;
        },
        actualizarOrdenDeMenu: function(valorPosicion) {
            const { POSICIONES } = this.formulario.catalogoTiposPosiciones;
            let actualizar = false;
            if(this.menus.seleccionadoEdicion.TipoPosicion.TipoPosicionId != valorPosicion && (valorPosicion == POSICIONES.SUPERIOR.llave || valorPosicion == POSICIONES.DERECHO.llave) ) {
                actualizar = true;
            }
            else if(valorPosicion == POSICIONES.SUPERIOR.llave) {
                actualizar = !(this.formulario.esMenuEspecial);
            }
            return actualizar;
        },
        evtIniciarProcesoAltaMenu: async function() {
            const FORMULARIO_ES_VALIDO = this.formularioEsValido();
            if(FORMULARIO_ES_VALIDO) {
                this.formulario.mostrarErrores = false;
                const PETICION_ALTA_MENU = await Promise.resolve(this.crearPeticionNuevoMenu());
                // SOLO PARA DESARROLLO DESPUES COMENTAR
                for (var pair of PETICION_ALTA_MENU.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                //
                const ES_NUEVO_MENU = true;
                $("#modal-formulario-menus").modal('hide');
                await Promise.resolve(this.guardarNuevoMenuBD(PETICION_ALTA_MENU, ES_NUEVO_MENU));
            }
        },
        guardarNuevoMenuBD: async function(peticionAPI, esNuevoMenu) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = (esNuevoMenu) 
                    ? api.SICPO.sistema.paginaweb.administracionDeMenus.AgregarNuevoMenuPW 
                    : api.SICPO.sistema.paginaweb.administracionDeMenus.ModificarMenuPW;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_AGREGAR_MENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_AGREGAR_MENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-formulario-menus").modal('show');
                } 
                else {
                    if(esNuevoMenu) {
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                    else if(!esNuevoMenu) {
                        const ES_DESPUES_DE_ACTUALIZACION = true;
                        await Promise.resolve(this.obtenerMenusBD(ES_DESPUES_DE_ACTUALIZACION, Satisfactorio));
                    }
                    this.limpiarFormulario();
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                $("#modal-formulario-menus").modal('show');
            }
        },
        crearPeticionNuevoMenu: async function() {
            const { catalogoPaginasDeInicio, catalogoTiposPosiciones, titulo, esDescarga, archivo, url, esMenuEspecial, elMenuParpadea, iconos } = this.formulario;
            let peticion = new FormData();
            let menuObj = {};
            menuObj.MenuId = -1;
            menuObj.RutaParaAccesar = (esMenuEspecial) ? archivo.IDENTIFICADOR : url;
            menuObj.Titulo = titulo;
            menuObj.EsDescarga = esMenuEspecial; // representa el valor de esDescarga y menuEspecial
            menuObj.Activo = true;
            menuObj.OrdenDelMenu -1;
            menuObj.EsMenuEspecial = esMenuEspecial;
            menuObj.ElMenuParpadea = elMenuParpadea;
            if(this.campoRequeridoEsValido(iconos.seleccionado) && this.mostrarIconos) {
                let iconoObj = { TipoIconoId: iconos.seleccionado.llave, Icono: null, UsablePorUsuario: false, Activo : false } // solo requerido el atributo TipoIconoId
                menuObj.TipoIcono = iconoObj;
            } 
            menuObj.PaginaDeInicio = { PaginaDeInicioId: catalogoPaginasDeInicio.valorDefinido, Activo: true };
            menuObj.TipoPosicion = { TipoPosicionId: catalogoTiposPosiciones.valorDefinido, Activo: true };
            if(esMenuEspecial)
                peticion.append(archivo.IDENTIFICADOR, archivo.objeto);
            peticion.append('ReferenciaArchivo', archivo.IDENTIFICADOR);
            peticion.append('Menu', JSON.stringify(menuObj));
            peticion.append('EsPrueba', false);
            return peticion;
        }, 
        formularioEsValido: function() { 
            let esValido = true;
            let camposObligatorios = [];
            const { catalogoPaginasDeInicio, catalogoTiposPosiciones, titulo, esDescarga, archivo, url, esEdicion, iconos } = this.formulario;
            camposObligatorios.push({ valor: catalogoPaginasDeInicio.valorDefinido, msjError: 'Debes seleccionar una página valida' });
            camposObligatorios.push({ valor: catalogoTiposPosiciones.valorDefinido, msjError: 'Debes seleccionar una posición valida' });
            camposObligatorios.push({ valor: titulo, msjError: 'Debes ingresar un titulo valido' });
            // RUTA DE ACCESO MENU
            if(esEdicion && archivo.esConSubidor && esDescarga) {
                camposObligatorios.push({ valor: archivo.objeto, msjError: 'Debes seleccionar un archivo valido' });
            }
            else if(!esEdicion && esDescarga){
                camposObligatorios.push({ valor: archivo.objeto, msjError: 'Debes seleccionar un archivo valido' });
            }

            if(this.mostrarIconos)
                camposObligatorios.push({ valor: iconos.seleccionado, msjError: 'Debes seleccionar un icono valido' });

            for(let i=0; i<camposObligatorios.length; i++) {
                let campo = camposObligatorios[i];
                if(!this.campoRequeridoEsValido(campo.valor)) {
                    this.formulario.mensajeError = campo.msjError;
                    this.formulario.mostrarErrores = true;
                    esValido = false;
                    break;
                }
            }
            return esValido;
        },
        limpiarFormulario: function() {
            this.formulario.tituloFormulario = 'Alta de menú';
            this.formulario.esEdicion = false;
            // campos para errores
            this.formulario.mostrarErrores = false;
            this.formulario.mensajeError = null;
            this.limpiarCatalogoPaginaDeInicio();
            this.limpiarCatalogoPosicion();
            this.limpiarCampoRutaDeAcceso();
            this.formulario.titulo = null;
            this.limpiarIconos();
            this.formulario.esMenuEspecial = false;
            this.formulario.elMenuParpadea = false;
            this.menus.seleccionadoEdicion = null;
        },
        limpiarCatalogoPaginaDeInicio: function() {
            // campos catalogo pagina de inicio (en caso de utilizar vista para no solo pagina web agregar -1 en valor definido y el parametro TipoPaginaId del catalogo)
            this.formulario.catalogoPaginasDeInicio.valorDefinido = 1;
            this.formulario.catalogoPaginasDeInicio.paginaSeleccionada = null;
            this.formulario.catalogoPaginasDeInicio.contRender ++;
        },
        limpiarCatalogoPosicion: function() {
            this.formulario.catalogoTiposPosiciones.valorDefinido = -1;
            this.formulario.catalogoTiposPosiciones.posicionSelccionada = null;
            this.formulario.catalogoTiposPosiciones.contRender ++;
        },
        limpiarCampoRutaDeAcceso: function() {
            this.formulario.esDescarga = false;
            this.limpiarCamposSubidor();
            this.formulario.url = null;
        },
        limpiarCamposSubidor: function() {
            this.formulario.archivo.esConSubidor = false;
            this.formulario.archivo.objeto = null;
            $("#archivo_menu").val('');
        },
        limpiarIconos: function() {
            this.formulario.iconos.seleccionado = null;
            this.formulario.iconos.contRender ++;
            this.formulario.iconos.requerido = false;
        },
        evtSeleccionDeIcono: function(evento,iconoEstaSeleccionada) {
            const LLAVE_ICONO_SELECCIONADO = evento.target.getAttribute('id');
            if(iconoEstaSeleccionada)
                this.formulario.iconos.seleccionado = this.formulario.iconos.lista.find(i => i.llave == LLAVE_ICONO_SELECCIONADO);
            else
                this.formulario.iconos.seleccionado = null;
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitchMenusActivos());
            });
            console.log('icono::',this.formulario.iconos.seleccionado);
        },
        recargarIconos: function() {

        },
        evtSubidorDeArchivo: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    //const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    const ARCHIVO = evento.target.files[0];
                    this.formulario.archivo.objeto = ARCHIVO;
                    this.formulario.archivo.esConSubidor = true;
                }
                else {
                    this.formulario.archivo.objeto = null;
                    this.formulario.archivo.esConSubidor = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtDescargarArchivo: function(rutaArchivo) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
           /*  a.target = () ? "_blank" : ''; */
           /*  a.href = (this.formulario.archivos.esVinculoExterno) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}` */
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
        },
        evtCambioPaginaInicio: function(evento) {
            this.formulario.catalogoPaginasDeInicio.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioPosicion: function(evento) {
            this.formulario.catalogoTiposPosiciones.valorDefinido = parseInt(evento.target.value);
            if(this.formulario.catalogoTiposPosiciones.valorDefinido != this.formulario.catalogoTiposPosiciones.POSICIONES.SUPERIOR.llave) {
                this.formulario.esMenuEspecial = false;
                this.formulario.esDescarga = false;
            }
        },
        evtCerrarFormulario: function() {
            $("#modal-formulario-menus").modal('hide');
            this.confirmarPerdidaDeModificaciones();
        },
        confirmarPerdidaDeModificaciones: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `Si cierras el formulario se perderá la información ingresada en el formulario\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo").modal('hide');
                    this.limpiarFormulario();
                },
                funcionCancelar: () => {
                    $("#modal-informativo").modal('hide');
                    $("#modal-formulario-menus").modal('show');
                }
            }
            $("#modal-informativo").modal('show');
        },
        evtSwitchActivacionVariosSubmenus: function() {
            this.menus.activarVariosMenus = $('#switch-cambio-estatus-modal-VAM').is(":checked");
        },
        evtCambiarEstatusMenus: async function() {
            const OPCIONES_PETICION = null;
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusMenus(OPCIONES_PETICION));
            console.log('PETICON_API::cambioestatus::',PETICON_API);
            const ES_CAMBIO_INDIVIDUAL = false;
            this.evtCerrarModalActivacion();
            await Promise.resolve(this.cambiarEstatusDeSubmenusBD(PETICON_API, ES_CAMBIO_INDIVIDUAL));
        },
        evtCambiarEstatusMenuIndividual: async function(evento, menu) {
            const ID_CHECK_MENU = evento.target.getAttribute('id');
            const OPCIONES_PETICION = {
                idChekMenu: ID_CHECK_MENU,
                menuSel: menu
            }
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusMenus(OPCIONES_PETICION));
            console.log('PETICON_API::cambioestatus::',PETICON_API);
            const ES_CAMBIO_INDIVIDUAL = true;
            this.cambiarEstatusDeSubmenusBD(PETICON_API, ES_CAMBIO_INDIVIDUAL);
        }, 
        crearPeticioParaCambioDeEstatusMenus: async function(opciones) {
            let peticion = {};
            if(this.campoRequeridoEsValido(opciones)) {
                const ES_ESTATUS_ACTIVO = $('#' + opciones.idChekMenu).is(":checked");
                let menuObj = {
                    MenuId: opciones.menuSel.MenuId,
                    Activo: ES_ESTATUS_ACTIVO,
                    EsDescarga: false,
                    EsMenuEspecial: false,
                    ElMenuParpadea: false,
                    TipoPosicion: opciones.menuSel.TipoPosicion
                };
                peticion.Menus = [menuObj];
            }
            else {
                const ES_ESTATUS_ACTIVO = $('#switch-cambio-estatus-modal-VAM').is(":checked");
                this.menus.seleccionados = this.menus.seleccionados.map(mObj => {
                    mObj.Activo = ES_ESTATUS_ACTIVO;
                    return mObj;
                });
                console.log('entro::else::',this.menus.seleccionados);
                peticion.Menus = this.menus.seleccionados;
            }
            peticion.EsPrueba = false;
            return peticion;
        },
        cambiarEstatusDeSubmenusBD: async function(peticionAPI, esContenidoIndividual) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = api.SICPO.sistema.paginaweb.administracionDeMenus.CambiarEstatusDeMenusPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_ESTATUS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_ESTATUS.data;
                let { SiHayError, Error, Satisfactorio, Menus } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    if(!esContenidoIndividual)
                        this.evtMostrarModalCambioEstatus();
                } 
                else {
                    if(!esContenidoIndividual)
                        this.limpiarModalEstatus();
                    const ES_DESPUES_DE_ACTUALIZACION = true;
                    await Promise.resolve(this.obtenerMenusBD(ES_DESPUES_DE_ACTUALIZACION, Satisfactorio));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        limpiarModalEstatus: function() {
            this.menus.activarVariosMenus = false;
            this.$nextTick(() => {
                $("#switch-cambio-estatus-modal-VAM").prop('checked',false);
            });
        },
        evtBusquedaMenus: async function(parametrosDeBusqueda) {
            this.menus.filtrosDeBusqueda = parametrosDeBusqueda;
            console.log('FILTROS::',this.menus.filtrosDeBusqueda);
            const ES_PARA_ACTUALIZAR = false;
            const MENSAJE_DE_ACTUALIZACION = null;
            // se limpian las variables de ordenamiento
            this.ordenamiento.listaOrdenamiento = [];
            this.ordenamiento.listaNuevoOrden = [];
            await Promise.resolve(this.obtenerMenusBD(ES_PARA_ACTUALIZAR, MENSAJE_DE_ACTUALIZACION));
        },
        obtenerMenusBD: async function(esDespuesDeActualizacion, mensajeDeActualizacion) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.paginaweb.administracionDeMenus.ObtenerMenusPW;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                const PETICION_API = {
                    PaginaId: this.menus.filtrosDeBusqueda.paginaId,
                    PosicionId: this.menus.filtrosDeBusqueda.posicionId,
                    Titulo: this.menus.filtrosDeBusqueda.titulo,
                    EsDescarga: this.menus.filtrosDeBusqueda.esDescarga,
                    EsMenuEspecial: this.menus.filtrosDeBusqueda.esMenuEspecial,
                    MenuParpadea: this.menus.filtrosDeBusqueda.menuParpadea,
                    EsPrueba: this.menus.filtrosDeBusqueda.titulo
                }
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(!esDespuesDeActualizacion)
                    comun.SeEstaCargandoInformacion(true);
                const PETICION_OBTENER_SUBMENUS = await axios.post(urlApi, PETICION_API, headerPeticion);
                const DATOS_PETICION = await PETICION_OBTENER_SUBMENUS.data;
                let { SiHayError, Error, Satisfactorio, Menus } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    this.menus.BD = (this.campoRequeridoEsValido(Menus)) ? Menus : [];
                    // crea lista de ordenamiento en posiciones donde se permite modificar
                    if(this.permiteMoodificarOrden) {
                        this.ordenamiento.listaOrdenamiento = this.menus.BD.filter(mbd => mbd.Activo).map(m => {
                            let menu = { ...m };
                            menu.Titulo = `<strong>Titulo</strong>: ${ menu.Titulo }<br>
                                           <strong>Pertenece a la página</strong>: ${ menu.PaginaDeInicio.Titulo }<br>
                                           <strong>Se muestra en la posición</strong>: ${ menu.TipoPosicion.Nombre }`;
                            menu.hover = false;
                            return menu;
                        }); 
                        console.log('this.menus.listaOrdenamiento::',this.ordenamiento.listaOrdenamiento);
                    }
                    // crea la tabla con los resultados de la busqueda
                    this.$nextTick(async () => {
                        await Promise.resolve(this.construirTablaDeMenus(this.menus.BD));
                        await Promise.resolve(this.persistirSwitchMenusActivos());
                    });
                    comun.SeEstaCargandoInformacion(false);
                    if(esDespuesDeActualizacion)
                        comun.mensajeDeAlerta(mensajeDeActualizacion, null, null);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        persistirSwitchMenusActivos: async function() {
            console.log('persistirSwitchSubmenusActivos::',this.menus.memoria);
            if(this.menus.memoria.length > 0) {
                this.menus.memoria.forEach(mObj => {
                    const ID_SWITCH_ACTIVO_MENU = `check-submenu-activo-VAM-${ mObj.MenuId }`;
                    $("#" + ID_SWITCH_ACTIVO_MENU).prop('checked',  mObj.EstaActivo.activo);
                });
            }
        },
        construirTablaDeMenus: async function(menus) {
            this.limpiarMenusSeleccionados();
            await Promise.resolve(this.darFormatoObjetosDeMenus(menus));
            $("#tabla-menus").off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
            $("#tabla-menus").bootstrapTable({  data: this.menus.memoria });      
            $("#tabla-menus").bootstrapTable('load',  this.menus.memoria);  
            $('#tabla-menus').on('check.bs.table',(e, row) => {
                this.evtSeleccionoMenu(e, row);
            });
            $('#tabla-menus').on('uncheck.bs.table',(e, row) => {
                 const TIPO_CHECK = 'UNO';
                this.evtRemoverMenusEnListaSeleccionados(e, row,TIPO_CHECK);
            });
            $('#tabla-menus').on('check-all.bs.table',(e, rows) => {
                this.evtSeleccionoTodos(e, rows);
            });
            $('#tabla-menus').on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                const TIPO_CHECK = 'MUCHOS';
                this.evtRemoverMenusEnListaSeleccionados(e, rowsBefore,TIPO_CHECK);
            });
            $('#tabla-menus').on('page-change.bs.table', (size, number) => {
                //console.log('entro::evento::');
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchMenusActivos());
                }); 
            });
            $('#tabla-menus').on('sort.bs.table', (name, order) => {
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchSubmenusActivos());
                });
            });
            // bs table no reconoce clases css del componenete, una vez que se cargan los datos se asigna las clases de de manera global 
            $("td[id^=switch-activo-inactivo-VAM]").addClass('switch-menu-activo-VAM');
            $("td[id^=slider-activo-inactivo-VAM]").addClass('slider-menu-activo-VAM');
        },
        evtSeleccionoMenu: function(e, row) {
            if(!this.menus.seleccionados.some(mObj => mObj.MenuId == row.MenuId)) {
                const MENU_ESTRUCTURA_BD = this.menus.BD.find(mObjBD => mObjBD.MenuId == row.MenuId);
                this.menus.seleccionados.push(MENU_ESTRUCTURA_BD);
            }
        },
        evtSeleccionoTodos: function(e, rows) {
            console.log('rows::',rows);
            this.menus.seleccionados = rows.map(mObj => {
                let menuObj = {...mObj};
                delete menuObj['EstaActivo'];
                return menuObj;
            })
            console.log('RGS::',this.menus.seleccionados);
        },
        evtRemoverMenusEnListaSeleccionados: function(e, rows, tipoCheck) {
            switch(tipoCheck) {
                case 'UNO':
                    this.menus.seleccionados = this.menus.seleccionados.filter(mObj => mObj.MenuId != rows.MenuId);
                    break;
                case 'MUCHOS':
                    // se remueven la paginacion de menus seleccionados
                    this.menus.seleccionados = this.menus.seleccionados.filter(mObj => {
                        return !rows.some(mRObj => {
                            return mObj.MenuId == mRObj.MenuId;
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        limpiarMenusSeleccionados: function() {
            this.menus.seleccionado = null;
            this.menus.seleccionados = [];
        },
        darFormatoObjetosDeMenus: async function(menus) {
            console.log('darFormatoObjetosDeMenus::',menus);
            this.menus.memoria = menus.map(mBD => {
                let objMenu = {...mBD};
                objMenu.EstaActivo = {
                    activo: (objMenu.Activo),
                    html: `<label id="switch-activo-inactivo-VAM-${ objMenu.MenuId }" class="switch-menu-activo-VAM">
                            <input id="check-submenu-activo-VAM-${ objMenu.MenuId }" type="checkbox">
                            <div id="slider-activo-inactivo-VAM-${ objMenu.MenuId }" class="slider-menu-activo-VAM"></div>
                           </label>`
                };
                return objMenu;
            });
        },
        evtMostrarFormulario: async function(esParaEdicion) {
            this.formulario.esEdicion = esParaEdicion;
            if(this.campoRequeridoEsValido(this.menus.seleccionadoEdicion))
                await Promise.resolve(this.cargarDatosDeMenuEnFormulario());
            $("#modal-formulario-menus").modal('show');
        },
        evtMostrarModalCambioEstatus: function() {
            $('#modal-cambio-estatus-VAM').modal("show");
        },
        evtCerrarModalActivacion: function() {
            $('#modal-cambio-estatus-VAM').modal("hide");
        },
        obtenerNombreDelArchivo: function(rutaArchivo) {
            return (this.campoRequeridoEsValido(rutaArchivo)) ? rutaArchivo.replace(/^.*[\\\/]/, '') : '';
        },
        formateadorHTMLAcciones: () => {
            return `<div>
                        <button id="editar-menu-pw-SICPO" type="button" class="btn btn-sm btn-xs btn btn-info texto-ajustable align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>
                    </div>`;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        obtenerIconosPJParaMenus: async function() {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.PJ.catalogos.C057TipoIconos;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = {
                    TipoIconoId: null,
                    conInactivos: false,
                    soloUsablePorUsuario: false,
                    esPrueba: false
                }
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_GET_ICONOS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_GET_ICONOS.data;
                let { SiHayError, Error, TiposIconos } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    this.formulario.iconos.lista = await Promise.resolve(this.darFormatoIconosPJ(TiposIconos));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        darFormatoIconosPJ: async function(iconos) {
            let listaDeIconos = [];
            if(this.campoRequeridoEsValido(iconos)) {
                listaDeIconos = iconos.map(i => {
                    let iconoObj = {};
                    iconoObj.llave = i.TipoIconoId;
                    iconoObj.imagen = i.Icono;
                    return iconoObj;
                });
            }
            return listaDeIconos;
        },
    },
    computed: {
        permiteMoodificarOrden() {
            return ((this.menus.filtrosDeBusqueda.posicionId == this.formulario.catalogoTiposPosiciones.POSICIONES.SUPERIOR.llave && !this.menus.filtrosDeBusqueda.esMenuEspecial)
                    || this.menus.filtrosDeBusqueda.posicionId == this.formulario.catalogoTiposPosiciones.POSICIONES.DERECHO.llave);
        },
        mostrarCaracteristicasExtra() {
            return (this.formulario.catalogoTiposPosiciones.valorDefinido == this.formulario.catalogoTiposPosiciones.POSICIONES.SUPERIOR.llave);
        },
        mostrarIconos() {
            return this.formulario.iconos.lista.length > 0 &&
                  (this.formulario.esMenuEspecial || this.formulario.catalogoTiposPosiciones.valorDefinido == this.formulario.catalogoTiposPosiciones.POSICIONES.IZQUIERDA.llave);
        }
    },
    mounted() {
        this.$nextTick(() => {
            $("#tabla-menus").bootstrapTable({  data: this.menus.BD });      
            $("#tabla-menus").bootstrapTable('load',  this.menus.BD); 
        });
        window.operateEvents = {
            "click #editar-menu-pw-SICPO": (e,val,row,index) => {      
                const MENU_ESTRUCTURA_BD = this.menus.BD.find(mbd => mbd.MenuId == row.MenuId);  
                if(this.campoRequeridoEsValido(MENU_ESTRUCTURA_BD))
                    this.menus.seleccionadoEdicion = {...MENU_ESTRUCTURA_BD};
                const ES_PARA_EDICION = true;  
                this.evtMostrarFormulario(ES_PARA_EDICION);
            },
            "click #eliminar-contenido-pw-SICPO": (e,val,row,index) => {          
                //this.evtEliminarContenido(row)
            },
            "click #eliminar-archivo-pw-SICPO": (e,val,row,index) => {          
                /* $("#tabla-archivos-contenido").bootstrapTable('remove', {
                    field: 'RutaDelArchivo',
                    values: [row.RutaDelArchivo]
                });
                this.formulario.archivos.identificadoresDeArchivos = this.formulario.archivos.identificadoresDeArchivos.filter(ia => ia.llave != row.RutaDelArchivo);
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                }); */
                /* console.log('archivos::',this.formulario.archivos.lista);
                console.log('identificadores::',this.formulario.archivos.identificadoresDeArchivos); */
            },
            "click #descargar-archivo-SICPO": (e,val,row,index) => {   
                /* if(row.ArchivoDeContenidoDeLaPaginaWebId > 0)       
                    this.evtDescargarArchivo(row.RutaDelArchivo)
                else
                    this.evtDescargarArchivoEnMemoria(row); */
            },
            'click :checkbox[id^=check-submenu-activo-VAM]': (e, value, row, index) => {
                this.evtCambiarEstatusMenuIndividual(e,row);
            },
            'click .icono-ampliar-texto': (e, value, row, index) => {
               // this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
    },
    async created() {
        await Promise.resolve(this.obtenerIconosPJParaMenus()); 
    },
}
</script>
<style scoped>
#modal-ordenamiento-menusPW .modal-lg {
    max-width: 45% !important;
}

#modal-ordenamiento-menusPW .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-ordenamiento-menusPW .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

#lista-ordenamiento-menus {
    border: 2px solid rgb(51, 49, 49);
    max-height: 335px;
    overflow: auto;
}

#modal-informativo .modal-lg {
    max-width: 30% !important;
}

#modal-informativo .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.btn-secondary:not(:disabled):not(.disabled).active, 
.btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size : 1vw;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

#modal-formulario-menus .modal-lg {
    max-width: 50% !important;
}

#modal-formulario-menus .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.deshabilitarSeccionCatalogos {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

#accion-estatus-menus h6:hover, #accion-estatus-menus h6:focus {
    text-decoration-line: underline;
    font-weight: bold;
    cursor: pointer;
}

.acciones-activacion-menus .btn-block{
    height: 45px;
    background-color: black;
}

.icono-activacion-menus {
    font-size : 4vw;
}

#modal-cambio-estatus-VAM .modal-lg {
    max-width: 25% !important;
}

#modal-cambio-estatus-VAM .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-cambio-estatus-VAM .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

.contenedor-gris {
    background-color: #323335;
    padding: 25px;
}

.titulo-contendor {
    background-color: #1b1919;
    padding: 13px 13px 5px 23px;
}

.seccion-filtrosDeBusqueda {
    margin-top: 3.5em;
}

#tabla-menus-SICPO-VADM table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.titulo-tabla {
    background-color: #1b1919;
    padding: 13px 13px 13px 23px;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch {
  position: relative;
  width: 60px;
  height: 34px;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #2ab934;
}

.switch:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.switch input:checked + .slider:before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(25px);
  transform: translateX(25px);
}

.slider:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch input:checked + .slider:after
{  
  content:'';
}
</style>

<style>
#tabla-menus-SICPO-VADM .search {
    width: 20rem;
}

#tabla-menus-SICPO-VADM .dropdown-toggle {
    width: 3.3rem;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-menu-activo-VAM {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-menu-activo-VAM input {display:none;}

.slider-menu-activo-VAM {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-menu-activo-VAM:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM {
  background-color: #2ab934;
}

.switch-menu-activo-VAM input:focus + .slider-menu-activo-VAM {
  box-shadow: 0 0 1px #2196F3;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-menu-activo-VAM:after {
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM:after {  
  content:'';
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/Menus/CAdministracionDeMenus.vue